import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hata: null, nerede: null, ayrinti: false }
  }

  static getDerivedStateFromError(hata) {
    return { hata }
  }

  componentDidCatch(hata, bilgi) {
    try {
      console.error('[ErrorBoundary] arayuz hatasi:', hata && hata.message, bilgi && bilgi.componentStack)
    } catch (e) {}
    this.setState({ nerede: bilgi && bilgi.componentStack })
  }

  render() {
    if (!this.state.hata) return this.props.children

    const kutu = {
      maxWidth: '620px', margin: '64px auto', padding: '28px',
      border: '1px solid #E5E7EB', borderRadius: '12px', background: '#FFFFFF',
      fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif', color: '#111827',
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    }
    const dugme = {
      padding: '10px 18px', borderRadius: '8px', border: 'none', cursor: 'pointer',
      background: '#4F46E5', color: '#fff', fontSize: '14px', fontWeight: 500,
    }
    const ikincil = { ...dugme, background: '#F3F4F6', color: '#374151' }
    const kod = {
      marginTop: '14px', padding: '12px', background: '#F9FAFB', borderRadius: '8px',
      fontSize: '11px', fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
      color: '#6B7280', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
      maxHeight: '220px', overflow: 'auto',
    }

    return (
      <div style={kutu}>
        <div style={{ fontSize: '17px', fontWeight: 600, marginBottom: '8px' }}>Bu ekran yüklenemedi</div>
        <div style={{ fontSize: '14px', lineHeight: 1.6, color: '#4B5563' }}>
          Panelde beklenmeyen bir hata oluştu. Verilerinizde bir kayıp yok — hata yalnızca bu ekranın
          görüntülenmesiyle ilgili. Sayfayı yenilemek çoğu durumda yeterli oluyor.
        </div>
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px', flexWrap: 'wrap' }}>
          <button style={dugme} onClick={() => window.location.reload()}>Sayfayı yenile</button>
          <button style={ikincil} onClick={() => { window.location.href = '/' }}>Ana sayfaya dön</button>
          <button style={ikincil} onClick={() => this.setState({ ayrinti: !this.state.ayrinti })}>
            {this.state.ayrinti ? 'Teknik ayrıntıyı gizle' : 'Teknik ayrıntı'}
          </button>
        </div>
        {this.state.ayrinti && (
          <div style={kod}>
            {String((this.state.hata && this.state.hata.message) || this.state.hata)}
            {this.state.nerede ? '\n' + this.state.nerede : ''}
          </div>
        )}
        <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '16px' }}>
          Sorun tekrarlıyorsa teknik ayrıntıyı kopyalayıp iletin.
        </div>
      </div>
    )
  }
}
